import Link from "next/link";
import { Landmark, MapPin, ArrowRight } from "lucide-react";
import MandalaWatermark from "./MandalaWatermark";

const TemplePujaCard = ({ templePuja }) => {
  const heroImage = templePuja?.media?.find((m) => m?.mediaUrl)?.mediaUrl;

  return (
    <Link
      href={`/e-pooja/temple/pujas/${templePuja.slug}`}
      className="group flex flex-col bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 overflow-hidden flex-shrink-0 w-[220px] sm:w-[240px] snap-start"
    >
      <div className="relative w-full aspect-[4/3] bg-gradient-to-br from-rose-50 to-orange-50 overflow-hidden">
        {heroImage ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={heroImage}
            alt={templePuja.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Landmark size={40} className="text-primary/20" />
          </div>
        )}
        {templePuja.templeName && (
          <div className="absolute top-3 left-3 bg-white/90 backdrop-blur px-2.5 py-1 rounded-full text-[10px] font-bold text-primary flex items-center gap-1 shadow-sm">
            <Landmark size={10} /> {templePuja.templeName}
          </div>
        )}
      </div>

      <div className="flex-1 flex flex-col p-4">
        <h3 className="font-bold text-sm text-gray-800 leading-snug line-clamp-2">
          {templePuja.name}
        </h3>
        {templePuja.templeLocation && (
          <p className="flex items-center gap-1 text-[11px] text-gray-400 mt-1.5">
            <MapPin size={11} /> {templePuja.templeLocation}
          </p>
        )}
        {templePuja.shortDescription && (
          <p className="text-xs text-gray-500 mt-2 leading-5 line-clamp-2">
            {templePuja.shortDescription}
          </p>
        )}
        <div className="mt-auto pt-4 flex items-center justify-between">
          <span className="text-xs font-bold text-primary flex items-center gap-1 group-hover:gap-1.5 transition-all">
            View Details <ArrowRight size={13} />
          </span>
        </div>
      </div>
    </Link>
  );
};

const TemplePujaDiscoverySection = ({ templePujas }) => {
  if (!templePujas || templePujas.length === 0) {
    return null;
  }

  return (
    <section id="temple-poojas" className="py-6 md:py-10 bg-background">
      <div className="container">
        <div className="flex items-center justify-center gap-2 mb-2">
          <MandalaWatermark
            className="w-6 h-6 text-primary animate-spin"
            style={{ animationDuration: "20s" }}
          />
          <h2 className="text-2xl md:text-4xl font-bold text-center">
            Book a Pooja at Famous <span className="text-primary">Temples</span>
          </h2>
          <MandalaWatermark
            className="w-6 h-6 text-primary animate-spin"
            style={{ animationDuration: "20s" }}
          />
        </div>
        <p className="text-center text-muted-foreground text-sm md:text-base mb-4">
          Participate by name and gotra — our temple priests perform the ritual on your behalf
        </p>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-2 snap-x snap-mandatory md:grid md:grid-cols-3 lg:grid-cols-6 md:overflow-visible">
          {templePujas.slice(0, 6).map((templePuja) => (
            <TemplePujaCard key={templePuja._id} templePuja={templePuja} />
          ))}
        </div>

        <div className="flex justify-center mt-6">
          <Link
            href="/e-pooja/temple/pujas"
            className="inline-flex items-center gap-1.5 text-sm font-bold text-primary hover:gap-2.5 transition-all"
          >
            View All Temple Poojas <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TemplePujaDiscoverySection;
